const siteColors = document.querySelectorAll('[name="color"]')

if (siteColors.length > 0) {
	siteColors.forEach(e => {
		e.addEventListener('change', _ => {
			const siteApp = document.querySelector('#app')
			siteApp.classList = e.value

			const computedColor = window.getComputedStyle(siteApp).getPropertyValue('--cl-theme-base')
			// document.querySelector('meta[name=theme-color]').content = computedColor

			document.querySelector('[site-current-color]').innerHTML = e.title
		})
	})
}

// show selector
function colorSelector() {
	if (event.key === 'Shift') {
		siteShiftClicks++
		if (siteShiftClicks >= 2) {
			document.documentElement.classList.toggle('is--color-picker')
		}
		setTimeout(() => (siteShiftClicks = 0), 200)
	}
}

let siteShiftClicks = 0
document.addEventListener('keyup', colorSelector, true)

// esc dismiss
document.addEventListener('keyup', _ => {
	const siteDocument = document.documentElement

	if (siteDocument.classList.contains('is--color-picker') && _.key === 'Escape') {
		siteDocument.classList.remove('is--color-picker')
	}
})

// active color
window.addEventListener('load', _ => {
	const siteApp = document.querySelector('#app')
	const computedColor = window.getComputedStyle(siteApp).getPropertyValue('--cl-theme-base')

	document.querySelector('[site-current-color]').innerHTML = document.querySelector('[name="color"]:checked').title
	// document.querySelector('meta[name=theme-color]').content = computedColor
})
